//const APIURL = process.env.REACT_APP_API_URL;
const APIURL = process.env.REACT_APP_API_URL;
const APIURLAUTH = process.env.REACT_APP_API_URL_AUTH;
let token = '';
export function getToken ( ) {
  let accessToken = ''
  try {
    const tokenLocal = JSON.parse(localStorage.getItem('user'));
    accessToken = tokenLocal.access_token
  } catch (error) {
    accessToken = ''
  }
  token = accessToken ? `Bearer ${accessToken}`: ''
  return token
}
getToken();

export const setToken = (tokenUser) => {
  token = `Bearer ${tokenUser}`;
}

export const APISERVICE = {

  get: async (url, params = "") => {
    try {
      const response = await fetch(`${APIURL}${url}${params}`, {
        headers: {
          Authorization: token,
        },
      });
      const data = await response.json();
      data.status = response.status;
      return data;
    } catch (error) {
      console.log(error);
    }
  },
  post: async (url, params = '', body) => {
    try {
      const response = await fetch(`${APIURL + url + params}`,{
        headers:{
          'content-type': 'application/json',
          Authorization:token
        },
        method: 'POST',
        body: JSON.stringify(body)
      });
      const data = await response.json();
      data.status = response.status;
      return data;
    } catch (err) {
      console.error(err);
    }
  },

  getInfoUser: async  ( params ) => {
    try{
      const response =  await fetch(`${APIURLAUTH}?access_token=${params}`, {
        headers: {
            Authorization: `Bearer ${params}`,
            Accept: 'application/json'
        }
      })
      if(!response.ok){
      }
      const data = await response.json();
      return data;

    }catch(error){
      console.error(error);
    }
  },

  postWithImage: async (url, params = '', body) => {
    try{
      const response = await fetch(`${APIURL + url}${params}`, {
        headers:{
          Authorization: token
        },
        method: 'POST',
        body: body
      })
  
      if(!response.ok){
      }
      const data = await response.json();
      return data;
    }catch(error){
      console.error(error);
    }
    
  }
};
